import BaseModal from "../../BaseComponents/BaseModal/BaseModal";
import { FileText, Calendar, CreditCard, Building2, DollarSign } from "lucide-react";
import styles from "./ViewReceiptModal.module.css";

const ViewReceiptModal = ({ open, onClose, receipt }) => {
  if (!receipt) return null;

  const isClientTransaction = receipt.customerName !== undefined;

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Receipt Details"
      width="680px"
      footer={
        <button className={styles.closeBtn} onClick={onClose}>
          Close
        </button>
      }
    >
      <div className={styles.receiptHeader}>
        <div className={styles.receiptIcon}>
          <FileText size={28} />
        </div>
        <div>
          <div className={styles.receiptNumber}>{receipt.receiptNumber}</div>
          <div className={styles.receiptSubtitle}>Payment Receipt</div>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>Receipt Information</div>
        <div className={styles.grid}>
          <div className={styles.field}>
            <div className={styles.label}>Receipt Number</div>
            <div className={styles.value}>{receipt.receiptNumber}</div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Issue Date</div>
            <div className={styles.value}>
              <Calendar size={14} className={styles.icon} />
              {receipt.issueDate}
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Payment Type</div>
            <div className={styles.value}>
              <span className={styles.badge}>{receipt.paymentType}</span>
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Status</div>
            <div className={styles.value}>
              <span className={`${styles.badge} ${styles.badgeSuccess}`}>{receipt.status}</span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>
          {isClientTransaction ? "Customer Information" : "Supplier Information"}
        </div>
        <div className={styles.grid}>
          <div className={styles.field}>
            <div className={styles.label}>Name</div>
            <div className={styles.value}>
              {isClientTransaction ? receipt.customerName : receipt.supplierName}
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Email</div>
            <div className={styles.value}>
              {isClientTransaction ? receipt.customerEmail : receipt.supplierEmail}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>Transaction Details</div>
        <div className={styles.grid}>
          <div className={styles.field}>
            <div className={styles.label}>Booking Reference</div>
            <div className={styles.value}>
              <span className={styles.bookingRef}>{receipt.bookingRef}</span>
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Linked Payment ID</div>
            <div className={styles.value}>
              <span className={styles.paymentRef}>{receipt.linkedPaymentId}</span>
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Payment Method</div>
            <div className={styles.value}>
              <CreditCard size={14} className={styles.icon} />
              {receipt.paymentMethod}
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.label}>Account</div>
            <div className={styles.value}>
              <Building2 size={14} className={styles.icon} />
              {receipt.account}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>Amount</div>
        <div className={styles.amountBox}>
          <DollarSign size={20} />
          <div className={styles.amountValue}>
            €{receipt.amount.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
          </div>
          <div className={styles.currency}>{receipt.currency}</div>
        </div>
      </div>

      {receipt.notes && (
        <div className={styles.section}>
          <div className={styles.sectionTitle}>Notes</div>
          <div className={styles.notesBox}>{receipt.notes}</div>
        </div>
      )}
    </BaseModal>
  );
};

export default ViewReceiptModal;